export default __webpack_public_path__ + "928e863bdd23d28534003de50a8eb775.png";